//@ts-nocheck
import { AccordionBody,AccordionHeader, AccordionItem,Row,Col, Button,} from "reactstrap";
import ExpVerticalTabs from "./ExpVerticalTabs";
import { useAppSelector } from "../../ReduxToolkit/Hooks";
import { useState } from "react";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import { useGetDarReport } from "./hooks/useExpense";
import { Btn } from "../../AbstractElements";

const ExpCommonAccordionItem = ({ item, accordianOpenData }) => {
  const { mix_layout } = useAppSelector((state) => state.themeCustomizer);
  const [modal, setModal] = useState(false);
  const [DarFlag, setDarFlag] = useState<boolean>(false);
  const [empID, setEmpID] = useState<number | null>(null);
  const [date, setDate] = useState<string>("");

  const { data: DarReportData, isLoading,isSuccess,} = useGetDarReport({
    enable: DarFlag,
    params: {
      date: date,
      employeeId: empID,
    },
  });

  const handleViewClick = () => {
    setDarFlag(true);
    setModal(true);
    setEmpID(item.employeeId);
    setDate(item.date);
  };

  const rowWidths = [2, 1, 2, 1, 1, 1, 1, 1, 1];
  const getBgColor = (item: any) => {
  if (item.isSunday) return "#87CEEB";
  if (item.totalFwCall < 4 && item.totalNCA == 0) return "#ffcccc";
  if(item.edited === 'Edited') return "#F9F2DF"   
  return "transparent";
};

const colBaseStyle = {
  padding: "4px 6px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: "black",
};

  return (
    <AccordionItem>
      <AccordionHeader
       targetId={item.audited == 0 ? null : item.id}
        style={{
          margin: 0,
          textAlign: "center",
          backgroundColor: getBgColor(item),
        }}>

        <Row className="w-100 align-items-center">

          <Col style={{...colBaseStyle,flex: rowWidths[0], }} >
          <span>{item.id}</span>
          </Col>

          <Col style={{...colBaseStyle,flex: rowWidths[1],}}>
          <span>{item.tripType === 0 ? "-" : item.tripType}</span>
          </Col>

          <Col style={{...colBaseStyle,flex: rowWidths[2],}} >
            <span
              style={{
                whiteSpace: "normal",
                wordBreak: "break-word",
                maxWidth: "120px",
                textAlign: "left",
                color: "black",
              }}
            >
            {item?.tripLocation
                ? item.tripLocation.split(",").map((loc, idx, arr) => (
                    <div key={idx}>
                      {loc.trim()}
                      {idx < arr.length - 1 ? "," : ""}
                    </div>
                  ))
                : "-"}
            </span>
          </Col>

          <Col style={{...colBaseStyle, flex: rowWidths[3],}}>
          <span>{item.requested}</span>
          </Col>

          <Col
            style={{...colBaseStyle, flex: rowWidths[4], }}>
            <span>{item.approved}</span>
          </Col>

          <Col
            style={{...colBaseStyle, flex: rowWidths[5],}}>
            <span>{item.audited}</span>
          </Col>

          <Col style={{...colBaseStyle,flex: rowWidths[6], }} >
            <span>{item.totalFwCall}</span>
          </Col>

          <Col style={{...colBaseStyle,flex: rowWidths[7], }}>
          <span>{item.totalNCA}</span>
          </Col>

          <Col style={{...colBaseStyle,flex: rowWidths[8],}}>
            <Button
              size="xs"
              color="primary"
              onClick={handleViewClick}
                style={{
                  borderRadius: "10px",
                  pointerEvents: Number(item.audited) == 0 ? "none" : "auto",
                  opacity: 1,
                }}
            >
              DAR
            </Button>
          </Col>
        </Row>
      </AccordionHeader>

      {/* ✅ Accordion Body */}
      <AccordionBody
        accordionId={item.id}
        style={{
          margin: 0,
          textAlign: "center",
          backgroundColor: item.isSunday
            ? "#87CEEB"
            : item.totalFwCall < 4 && item.totalNCA == 0
            ? "#ffcccc"
            : item.edited === "Edited" ? "#F9F2DF"
            : null,
        }}
      >
        <ExpVerticalTabs data={item} openDates={accordianOpenData} />
      </AccordionBody>
    
      {modal && (
        <>
          <RouteModal
            toggle={() => {
              setModal(!modal);
              setDarFlag(false);
            }}
            size="xl"
            isOpen={modal}
            content={
              <>
                <RouteModal
                  toggle={() => {
                  setModal(!modal);
                  setDarFlag(false);
                  }}
                  size="xl"
                  isOpen={modal}
                  content={
                    <>
                      <BasicDataTable
                        pagination={false}
                        showSpinner={isLoading}
                        columns={DarReportColums}
                        Title="Dar List Report"
                        data={
                          (!isLoading &&
                            isSuccess &&
                            DarReportData?.formatedData) ||
                          []
                        }
                        search={false}
                      />
                      <Btn
                        style={{
                          backgroundColor: "#F9FAFC",
                          color: "#000",
                          border: "1px solid #E0E0E0",
                          marginTop: "6px",
                        }}
                        type="button"
                        onClick={() => setModal(false)}>
                        Cancel
                      </Btn>
                    </>
                  }
                />
              </>
            }
          />
        </>
      )}
    </AccordionItem>
  );
};

export default ExpCommonAccordionItem;
const DarReportColums = [
  {
    name: "Sr No.",
    selector: (row: { Sr_No: string }) => row.Sr_No || "-",
    width: "100px",
  },
  {
    name: "Location/Account",
    selector: (row: { Stownname: string }) => row.Stownname || "-",
    width: "160px",
    wrap: true,
  },
  {
    name: "Customer Details",
    selector: (row: { OutletName: string }) => row.OutletName || "-",
    width: "160px",
    wrap:true
  },
  {
    name: "Tags",
    selector: (row: { Tag: string }) => row.Tags || "-",
    wrap: true,
    width: "120px",
  },
  {
    name: "Agenda",
    selector: (row: { Agenda: string }) => row.Agenda || "-",
    width: "150px",
  },
  {
    name: "Joint Working",
    selector: (row: { JointWorking: string }) => row.JointWorking || "-",
    width: "150px",
  },
  {
    name: "Planned",
    selector: (row: { PlanPlannedned: string }) => row.Planned || "-",
  },
  {
    name: "Input",
    selector: (row: { SgpiOut: string }) => row.SgpiOut || "-",
    wrap: true,
    width: "120px",
  },
  {
    name: "Brands Details",
    selector: (row: { Edetailing: string }) => row.Edetailing || "-",
    width: "150px",
  },
  {
    name: "SGPI",
    selector: (row: { Sgpi: string }) => row.Sgpi || "-",
  },
];
